import {FC} from 'react'
import {Badge, Form} from 'react-bootstrap'
import {TradeProvision} from '../../trade-provisions/core/_models'

type Props = {
  tradeProvisionDetail: TradeProvision
}

const TradeProvisionsDetailView: FC<Props> = ({tradeProvisionDetail}) => {
  const renderValue = (value?: string | number | boolean | null) => {
    if (value === null || value === undefined || value === '') return '-'
    if (typeof value === 'boolean') return value ? 'Yes' : 'No'
    if (value.toString().includes(';'))
      return (
        <div className='d-flex gap-1'>
          {value
            .toString()
            .split(';')
            .map((item, index) => (
              <Badge bg='light' key={index}>
                {item}
              </Badge>
            ))}
        </div>
      )
    return String(value)
  }

  const renderLegallyEnforceable = (value?: number | null) => {
    if (value === 1) return 'Yes'
    if (value === 0) return 'No'
    return '-'
  }

  return (
    <div className='detail-trade-provision'>
      <div className='row mb-4'>
        <div className='col-md-12 mb-3'>
          <Form.Label>Provision</Form.Label>
          <div className='data-value fw-semibold'>
            {renderValue(tradeProvisionDetail.provision)}
          </div>
        </div>
        <div className='col-md-12 mb-3'>
          <Form.Label>Legally Enforceable</Form.Label>
          <div className='data-value'>
            {renderLegallyEnforceable(tradeProvisionDetail.legally_enforceable)}
          </div>
        </div>
        <div className='col-md-12 mb-3'>
          <Form.Label>Description</Form.Label>
          <div
            className='data-value'
            dangerouslySetInnerHTML={{__html: tradeProvisionDetail.description || '-'}}
          />
        </div>
        <div className='col-md-12 mb-3'>
          <Form.Label>Keyword Combinations</Form.Label>
          <div className='data-value' style={{whiteSpace: 'pre-wrap'}}>
            {renderValue(tradeProvisionDetail.keyword_combinations)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TradeProvisionsDetailView
